import Button, {
  ButtonVariantEnum,
} from "@booking/components/atoms/forms/Button";
import { gaClickAttrs } from "@booking/utils/tracking";
import clsx from "clsx";
import React from "react";

import { ColorEnum } from "@/enums";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./ClearFilter.module.css";

const ref = "clear-filter";

interface ClearFilterProps extends Partial<CommonProps> {
  eventGroup?: string;
  updater: React.MouseEventHandler<HTMLButtonElement>;
  name: string;
}

function useClearFilter(props: ClearFilterProps) {
  const { eventGroup = "Filters", id = createId(ref), updater, name } = props;
  const className = clsx(styles[ref], props.className);

  return {
    className,
    eventGroup,
    id,
    name,
    updater,
  };
}

function ClearFilter(props: ClearFilterProps) {
  const { className, eventGroup, id, name, updater } = useClearFilter(props);

  return (
    <Button
      className={className}
      id={id}
      color={ColorEnum.BLUE}
      variant={ButtonVariantEnum.PLAIN}
      onClick={updater}
      {...gaClickAttrs({ eventGroup, click: `${name}_click` })}
    >
      {name === "clear_all" ? "Clear All" : "Clear Filter"}
    </Button>
  );
}

export default ClearFilter;
export { ClearFilter, type ClearFilterProps };
